// Module
var code = "<p>The #1 Quoting, Invoicing and Small Business App</p>\n";
// Exports
module.exports = code;